import { RUN_STATUSES } from "src/business-components/RunsStatusBars/RunsStatusBars.constants";
import type { RunStatus } from "src/queries/pipelines/pipelineRuns.types";
import { caseInsensitiveCompare } from "src/utils/string/caseInsensitiveCompare";

export const getRunStatusWithRetries = (
  runs: { status: RunStatus }[]
): RunStatus => {
  if (!runs?.length) {
    return RUN_STATUSES.UNKNOWN;
  }

  if (runs.length === 1) {
    return runs[0].status;
  }

  if (caseInsensitiveCompare(runs[0].status, RUN_STATUSES.FAILED)) {
    return RUN_STATUSES.FAILED_WITH_ERRORS;
  }

  // the latest attempt is still in flight - it has no final status to aggregate yet
  if (caseInsensitiveCompare(runs[0].status, RUN_STATUSES.RUNNING)) {
    return RUN_STATUSES.RUNNING;
  }

  // Check if any run has failed
  for (const run of runs) {
    if (caseInsensitiveCompare(run.status, RUN_STATUSES.FAILED)) {
      return RUN_STATUSES.COMPLETED_WITH_ERRORS;
    }
  }

  return RUN_STATUSES.COMPLETED_WITH_RETRIES;
};
